import { createElement } from "react";
import React from "react";
import { ContextMsg, useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { DialogBody, Text as Text$, Spinner, DialogActions, tokens, Image, Textarea, Input, Field, DialogContent, DialogTitle, DialogSurface, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { SaveRegular, ImageAddRegular, DismissRegular, AddRegular } from "@fluentui/react-icons";
import { take, length, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { NewTrack, S3UploadFile } from "../Shared/SharedModels.jsx";
import { toastServerError, Track } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";

export function CreateTrackDialog(createTrackDialogInputProps) {
    let elems_10, el_4, el_2, el, el_46, elems_9, props_69, el_6, el_28, elems_6, elems_1, el_11, elems_3, el_16, elems_5, el_44, elems_8, el_34, el_32, el_30, el_42, name_9, elemsToUse;
    const callback = createTrackDialogInputProps.callback;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const description = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const patternInput_4 = reactApi.useState(false);
    const patternInput_5 = reactApi.useState(undefined);
    const setFile = patternInput_5[1];
    const file = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const setImg = patternInput_6[1];
    const img = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsSending = patternInput_7[1];
    const isSending = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsOpen = patternInput_8[1];
    const el_48 = Dialog;
    return createElement(el_48, createObj(ofArray([["open", patternInput_8[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_10 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            appearance: "primary",
            children: "Opprett læringsløp",
            icon: (el = AddRegular, createElement(el, {})),
        })),
    })), (el_46 = DialogSurface, createElement(el_46, createObj(singleton_1((elems_9 = [(props_69 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        as: "h1",
        children: "Opprett læringsløp",
    })), (el_28 = DialogContent, createElement(el_28, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        height: 70,
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(patternInput_3[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => append(singleton(["label", "Navn"]), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
            placeholder: "ADHD barn 4-6 år",
            onChange: (_arg_1, value_1_10) => {
                const v = value_1_10;
                patternInput_1[1](v.value);
                patternInput_3[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        height: 100,
    }], (elems_3 = [(el_16 = Field, createElement(el_16, createObj(toList(delay(() => append(singleton(["label", "Beskrivelse"]), delay(() => append(patternInput_4[0] ? append(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : ((description.length > 5000) ? append(singleton(["validationMessage", `Beskrivelse kan ikke være lengre enn 5000 tegn (${description.length}/5000)`]), delay(() => singleton(["validationState", "error"]))) : append(singleton(["validationMessage", `${description.length}/5000`]), delay(() => singleton(["validationState", "none"])))), delay(() => {
        let matchValue_1, el_13;
        return singleton(["children", (matchValue_1 = tryHead([(el_13 = Textarea, createElement(el_13, {
            style: {
                height: 70,
            },
            value: description,
            onChange: (_arg_2, value_1_16) => {
                const v_1 = value_1_16;
                patternInput_2[1](v_1.value);
                patternInput_4[1](isNullOrWhiteSpace(v_1.value));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("input", {
        id: "image-select-input-create-track",
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                const f = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg_3) => {
                    const matchValue_2 = reader.result;
                    if (typeof matchValue_2 === "string") {
                        const base64data = matchValue_2;
                        setFile(f);
                        setImg(base64data);
                    }
                });
                reader.readAsDataURL(f);
            }
        },
        style: {
            display: "none",
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_5 = toList(delay(() => {
        let i, el_18, el_26, elems_4, el_24;
        return (file != null) ? ((img != null) ? ((i = img, append(singleton((el_18 = Image, createElement(el_18, {
            style: {
                width: 95 + "%",
                maxWidth: 400,
                maxHeight: 250,
                minHeight: 150,
            },
            fit: "contain",
            src: i,
        }))), delay(() => {
            let el_22, el_20;
            return singleton((el_22 = Button, createElement(el_22, {
                children: "Slett bilde",
                size: "small",
                onClick: (_arg_4) => {
                    setFile(undefined);
                    setImg(undefined);
                },
                icon: (el_20 = DismissRegular, createElement(el_20, {})),
                appearance: "outline",
            })));
        })))) : singleton((el_26 = Button, createElement(el_26, createObj(ofArray([["onClick", (_arg_5) => {
            document.getElementById("image-select-input-create-track").click();
        }], ["style", {
            width: 95 + "%",
            maxWidth: 400,
            maxHeight: 250,
            minHeight: 150,
            borderStyle: "dashed",
            borderColor: tokens.colorBrandBackgroundStatic,
            borderWidth: 1,
        }], (elems_4 = [(el_24 = ImageAddRegular, createElement(el_24, {
            fontSize: 48,
            primaryFill: tokens.colorBrandForeground2,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))))) : singleton((el_26 = Button, createElement(el_26, createObj(ofArray([["onClick", (_arg_5) => {
            document.getElementById("image-select-input-create-track").click();
        }], ["style", {
            width: 95 + "%",
            maxWidth: 400,
            maxHeight: 250,
            minHeight: 150,
            borderStyle: "dashed",
            borderColor: tokens.colorBrandBackgroundStatic,
            borderWidth: 1,
        }], (elems_4 = [(el_24 = ImageAddRegular, createElement(el_24, {
            fontSize: 48,
            primaryFill: tokens.colorBrandForeground2,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))), (el_44 = DialogActions, createElement(el_44, createObj(ofArray([["position", "end"], (elems_8 = [(el_34 = DialogTrigger, createElement(el_34, {
        disableButtonEnhancement: true,
        children: (el_32 = Button, createElement(el_32, {
            disabled: isSending,
            icon: (el_30 = DismissRegular, createElement(el_30, {})),
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_42 = Button, createElement(el_42, createObj(toList(delay(() => append(singleton(["disabled", ((isNullOrWhiteSpace(name) ? true : isNullOrWhiteSpace(description)) ? true : (description.length > 5000)) ? true : isSending]), delay(() => {
        let el_36;
        return append(!isSending ? singleton(["icon", (el_36 = SaveRegular, createElement(el_36, {}))]) : empty(), delay(() => append(singleton(["appearance", "primary"]), delay(() => append(singleton(["onClick", (_arg_6) => {
            setIsSending(true);
            const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let file_1;
                return ((file_1 = file, PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    if (file_1 != null) {
                        const f_1 = file_1;
                        return startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_7) => {
                            let res;
                            const MimeType = f_1.type;
                            res = (new S3UploadFile(f_1.name, MimeType, _arg_7));
                            return Promise.resolve(res);
                        });
                    }
                    else {
                        return Promise.resolve(undefined);
                    }
                })))).then((_arg_8) => {
                    let pr_1;
                    const pr = startAsPromise(Track.Add(new NewTrack(name, description, _arg_8)));
                    pr_1 = (pr.then((res_1) => {
                        let tupledArg;
                        if (res_1.tag === 1) {
                            switch (res_1.fields[0].tag) {
                                case 1: {
                                    errorToast(setCtx, "addTrackErrorValidationFailed", "Kunne ikke opprette læringsløp", "Noen felter er tomme eller ugyldige", undefined);
                                    setIsSending(false);
                                    break;
                                }
                                case 2: {
                                    errorToast(setCtx, "addTrackErrorUploadImageError", "Kunne ikke opprette læringsløp", "Noe gikk galt ved bildeopplastning", undefined);
                                    setIsSending(false);
                                    break;
                                }
                                default: {
                                    errorToast(setCtx, "addTrackErrorConflict", "Kunne ikke opprette læringsløp", "Det finnes allerede læringsløp med dette navnet", undefined);
                                    setIsSending(false);
                                }
                            }
                        }
                        else {
                            const track = res_1.fields[0];
                            setIsSending(false);
                            callback(track);
                            setIsOpen(false);
                            setCtx((tupledArg = [track.Id, track.Name], new ContextMsg(8, [tupledArg[0], tupledArg[1]])));
                            successToast(setCtx, `addTrackSuccess${track.Id}`, "Læringsløp opprettet", `læringsløp ${track.Name} ble opprettet`);
                        }
                    }));
                    void (pr_1.catch((ex) => {
                        setIsSending(false);
                        toastServerError(setCtx, ex);
                    }));
                    return Promise.resolve();
                });
            }));
            void pr_2;
        }]), delay(() => {
            let elems_7;
            return singleton((elems_7 = toList(delay(() => {
                let el_38, el_40;
                return isSending ? singleton((el_38 = Spinner, createElement(el_38, {
                    size: "tiny",
                }))) : singleton((el_40 = Text$, createElement(el_40, {
                    children: "Lagre",
                })));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))]));
        }))))));
    })))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))]), (name_9 = DialogBody, createElement(name_9, {
        children: reactApi.Children.toArray(Array.from(props_69)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])))))], (elemsToUse = ((length(elems_10) <= 2) ? elems_10 : take(2, elems_10)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=CreateTrack.jsx.map
